import chaletApi from "api/chaletApi";
import { GetTransportDriversRequestBody } from "types/api/GetTransportDriversRequestBody";
import { ChaletApiResponse } from "types/ChaletApiResponse";
import { TransportDriver } from "types/TransportDriver";

const TransportDriverService = chaletApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransportDrivers: builder.query<TransportDriver[], GetTransportDriversRequestBody>({
      query: (params) => ({
        method: "GET",
        params,
        url: `/transport-drivers/all`,
      }),
      transformResponse: (response: ChaletApiResponse<TransportDriver[]>) => response.data,
      providesTags: ["TransportDrivers"],
    }),
    verifyTransportDriver: builder.mutation<TransportDriver, number>({
      query: (id) => ({
        method: "PUT",
        url: `/transport-drivers/${id}/verify`,
      }),
      transformResponse: (response: ChaletApiResponse<TransportDriver>) => response.data,
    }),
    convertToDeliveryDriver: builder.mutation<TransportDriver, number>({
      query: (id) => ({
        method: "PUT",
        url: `/transport-drivers/${id}/to-delivery-driver`,
      }),
      transformResponse: (response: ChaletApiResponse<TransportDriver>) => response.data,
    }),
    getTransportDriver: builder.query<TransportDriver, number>({
      query: (id) => ({
        method: "GET",
        url: `/transport-drivers/${id}`,
      }),
      transformResponse: (response: ChaletApiResponse<TransportDriver>) => response.data,
    }),
    toggleTransportDriverActivity: builder.mutation<
      TransportDriver,
      { currentVehicleId?: number; transportDriverId?: number }
    >({
      query: ({ transportDriverId }) => ({
        method: "PUT",
        url: `/transport-drivers/${transportDriverId}/deactivate`,
      }),
      transformResponse: (response: ChaletApiResponse<TransportDriver>) => response.data,
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // Invalidate the transport drivers cache to trigger a refetch
          dispatch(TransportDriverService.util.invalidateTags(["TransportDrivers"]));
        } catch (error) {
          // Error handling is done in the component
        }
      },
    }),
  }),
  overrideExisting: true,
});

export default TransportDriverService;
